module.exports = __webpack_public_path__ + "03_medium_grey.ac37f7f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_medium_grey.png
// module id = yPd7
// module chunks = 0